import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { EnvironmentLoaderService } from 'src/app/services/environment-loader.service';

@Directive({
    selector: '[feature-toggle]',
    standalone: false
})
export class FeatureToggleDirective implements OnInit {
  @Input() feature: string;

  constructor(private el: ElementRef, private environmentLoader: EnvironmentLoaderService) {}

  ngOnInit(): void {
    const show = this.environmentLoader.isFeatureEnabled(this.feature);
    this.el.nativeElement.hidden = !show;
    if (!show) this.el.nativeElement.style.display = 'none';
  }
}
